import {
  observable,
  makeAutoObservable
} from "mobx";
import {
  FormValidator
} from "@formstore/FormValidator";

import { v4 as uuid } from "uuid";
import { TableStore } from "../TableStore";
import { BaseColumn } from "../columns/BaseColumn";
import { _STATUS, DataState, singleReferNullableType } from "../types";
import { _ } from "ynf-core-middleware";
import { ToolBarStore } from "./ToolBarStore";

export enum BillStatusType {
  OPEN = '0',
  AUDIT = '1',
  AUDITED = '2',
  STOP = '3',
  DisapproveDraft = '4'
}
type setValueOptions = {
  markDirty: boolean
}
export class BaseRowStore <T> {
  static DataState = DataState
  // 是否选中
  selected: boolean;
  // 行只读
  $readOnly: boolean | undefined;
  // 唯一键
  rowKey: string;
  // 行数据存储
  data: any;
  // 内部使用
  _timer: any;
  // tableStore
  // 序号 order
  order: number
  tableStore: T | any;
  // 异常信息map，key:异常错误内容数组
  errs: Map<string, string[]>;
  // 是否校验
  isValidate: boolean;
  // 表单校验工具类
  formValidator;
  // eslint-disable-next-line no-use-before-define
  children?: Array<BaseRowStore<T>>;
  // 校验信息收集
  validators: Map<string, any> = new Map();
  // 行内工具栏
  toolBarStore?: any;
  constructor(tableStore: T | any, src: any) {
    if (!(tableStore instanceof TableStore)) {
      console.warn('The first parameter for instantiating rowStore is not of type tableStore! Please check.')
    }
    this.tableStore = tableStore;
    this.rowKey = src?.[tableStore?.primaryKey] || uuid();
    /**
    * @deprecated This property is deprecated. Use getChildren() instead.
    */
    this.children = src.children;
    this.$readOnly = undefined;
    this.order = -1;
    this.data = src;
    this.isValidate = true;
    this.errs = observable.map();
    this.selected = false;
    this.formValidator = new FormValidator();
    this.toolBarStore = new ToolBarStore(this)
    makeAutoObservable(
      this,
      {
        // data 数据不到 cell 级别
        // data: false,
        rowKey: false,
        tableStore: false,
        formValidator: false,
        _timer: false,
        initValidators: false,
        debounceValidate: false,
        dataToJson: false
      },
      { autoBind: true }
    );
    // 初始化Validators
    this.initValidators();
  }

  // private parseEntityData(src: any, isEntity: boolean) {
  //   if (!isEntity) return src
  //   const newSrc: any = {}
  //   Object.keys(src).map(field => {
  //     const newField = this.ignoreField(field) ? field : this.getAliasByColumnsField(field)
  //     newSrc[newField] = src[field]
  //   })
  //   return newSrc
  // }

  // private ignoreField(field: string) {
  //   return field === _STATUS
  // }

  /**
   * 原则上storeAlias 和 field 相同，如果不同优先从Column 上获取
   *
   * */
  private getAliasByColumnsField(field: string) {
    let storeAlias = field
    this.tableStore.columns.forEach((value: BaseColumn) => {
      if (value.field === field) {
        storeAlias = value.storeAlias
      }
    })
    return storeAlias
  }

  /**
   * 设置校验
   */
  setValidate() {
    this.isValidate = !this.isValidate;
  }

  get_Status(): string | undefined {
    return this.getTrueValue(_STATUS);
  }

  set_Status(status: string) {
    this.setTrueValue(_STATUS, status)
  }

  isDeleteState() {
    return this.get_Status() === DataState.Delete
  }

  /**
   * 获取主组织field
   * @returns masterOrgField
   */
  getMasterOrgField() {
    let result = '';
    this.tableStore.fieldsArr.forEach((item: any) => {
      if (item?.isMasterOrg && item.isMasterOrg === true) {
        result = this.getAliasByColumnsField(item?.storeField)
      }
    })
    return result
  }

  get isInsertState() {
    return this.get_Status() === DataState.Insert
  }

  deleteState() {
    delete this.data._status;
  }

  /**
   * 初始化校验逻辑，再initCoumun后执行
   */
  initValidators() {
    // this.tableStore.columns?.forEach((column) => {
    //   column &&
    //     this.validators.set(
    //       column.storeAlias,
    //       column.validator()
    //     );
    // });
  }

  getColumns(storeAlias: string) {
    return this.tableStore.columns.get(storeAlias)
  }

  /**
   * 根据store别名 获取值
   * @param storeAlias 别名
   * @returns
   */
  getValue(storeAlias?: string): any {
    if (!storeAlias) {
      return this.data;
    }
    const column = this.getColumns(storeAlias);
    const value = column?.value(this)// 兼容老版本 field 随便定义导致找不到对应关系问题
    return value != undefined ? value : this.getTrueValue(storeAlias)
  }

  /**
   * 获取真实的值
   * @param key key
   * @returns
   */
  getTrueValue(key: string) {
    return _.get(this.data, key);
  }

  /**
   * 设置真实值
   * @param key 保存key
   * @param value 保存value
   * @param isTree a.b 是否对象穿透
   */
  setTrueValue(key: string, value: any, isTree?: boolean) {
    if (isTree) {
      _.set(this.data, key, value)
    } else {
      this.data[key] = value
    }
  }

  /**
   * 触发校验
   */
  debounceValidate() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => {
      this.isValidate && this.validate();
    }, 600);
  }

  /**
   * 设置值
   * @param storeAlias key
   * @param value value
   */
  setValue(storeAlias: string, value: any, options?: setValueOptions): void {
    let column = this.getColumns(storeAlias);
    if (!column) column = this.tableStore.addColumns({ storeAlias });
    if (!column) {
      throw new Error(`setValue 必须包含key` + '');
    }
    // 设置更新标识
    if (
      this.get_Status() !== DataState.Insert &&
      options?.markDirty !== false
    ) {
      this.set_Status(DataState.Update);
    }
    column.setValue(value, this);
    this.debounceValidate();
    this.tableStore.hooks?.afterRowSetValue?.forEach?.((fn: Function) =>
      fn(this)
    );
  }

  /**
   * 这种entire
   *
   */

  setEntityValue(field: string, value: any) {
    this.setValue(this.getAliasByColumnsField(field), value)
  }

  /**
   * 设置选择状态
   * @param flag 选中状态，默认是true
   */
  setSelected(flag: boolean = true) {
    this.selected = flag;
    // 如果开启跨页多选，处理跨页数据
    if (this.tableStore.multiplePageSelected) {
      if (flag) {
        // table 调用了setSelectRowKeys 也调用了 select 方法
        const items = this.tableStore.multiplePageSelectedData.filter((item: BaseRowStore<any>) => item.rowKey === this.rowKey)
        items.length === 0 && this.tableStore.multiplePageSelectedData.push(this);
      } else {
        this.tableStore.removeMultiplePageSelectedDataByRowKeys([this.rowKey]);
      }
    }
  }

  /**
   * 获取rowStore JSON 数据
   * @returns json
   */
  dataToJson() {
    return this.getEntityValue();
  }

  dataEntityToJson() {
    return this.getEntityValue();
  }

  /**
   *
   * @returns 获取真实值 默认行为 用真实的field返回， 没有则原样返回
   */
  getEntityValue() {
    const { children, ...other } = this.data
    let newOther : any = {}
    Object.keys(other)?.map(key => {
      const column = this.getColumns(key) ;
      newOther[key] = column?.getEntityValue(key, this) || this.getTrueValue(key)
    })
    let newChildren = children?.map( (row : BaseRowStore<any>) => row.getEntityValue())
    return {...newOther, children : newChildren}
  }

  // parseTree(data: any) {
  //   if (!data.children) {
  //     // this.data
  //     Object.keys(data)?.map(key => {
  //       data[key] = this.getValue(key)
  //     })
  //     return data
  //   }
  //   // 树形表处理
  //   if (data.children && data.children.length > 0) {
  //     data.children = data.children.map((childRowStore: BaseRowStore<any>) => {
  //       return this.parseTree(childRowStore?.data);
  //     });
  //   }
  //   return data
  // };



  /**
   * 设置行只读
   * @param b
   */
  setReadOnly(b: boolean) {
    this.$readOnly = b;
  }

  /**
   * rowStore 校验方法
   * @param key 根据key 校验
   * @returns 校验错误信息
   */
  validate(key?: string): any {
    const validateFields: any = [];
    if (key) {
      const column = this.getColumns(key);
      if (!column) {
        return
      }
      this.errs.delete(column.storeAlias);
      this.collectValidationInfo(validateFields, column)
    } else {
      this.tableStore?.columns?.forEach((column: BaseColumn) => {
        this.errs.delete(column.storeAlias);
        this.collectValidationInfo(validateFields, column)
      });
    }
    const errors = this.formValidator.validate(validateFields);
    Object.keys(errors.errDetail).forEach((key) => {
      const errs: string[] = [];
      Object.keys(errors.errDetail[key]).forEach((k) => {
        errs.push(errors.errDetail[key][k]);
      });
      this.errs.set(key, errs);
    });
    return errors;
  }

  private collectValidationInfo(validateFields: Array<any> , column: BaseColumn) {
    validateFields.push({
      fieldName: column.caption,
      fieldAlias: column.storeAlias,
      value: this.getValue(column.storeAlias),
      validators: column.validator()
    });
  }

  /**
   * 获取只读属性
   */
  get readOnly(): Function {
    return (key: string) => {
      // 编辑态 为保证性能 滑过才变为编辑态
      if (this.tableStore.isEdit) {
        if (
          this.tableStore.currentActiveRowKey === this.rowKey ||
          this.tableStore.currentHoverRowKey === this.rowKey
        ) {
          return this.getColumns(key)?.isReadOnly;
        }
      } else {
        const _readOnly = this.getColumns(key)?.isReadOnly
        if (_readOnly !== undefined) {
          return _readOnly
        }
        if (this.$readOnly !== undefined) {
          return this.$readOnly
        }
        if (this.tableStore.readOnly !== undefined) {
          return this.tableStore.readOnly
        }
      }

      return true

      // 如果table是只读，返回只读 原来逻辑
      // if (this.tableStore.readOnly === true) {
      //   return this.tableStore.readOnly;
      // } else {
      //   // 如果 当前行 只读，返回只读
      //   if (this.$readOnly === true) {
      //     return true;
      //   } else {
      //     // 如果是 当前活动行或hover行和当前rowKey 一直，返回，列上设置的readOnly 属性
      //     if (
      //       this.tableStore.currentActiveRowKey === this.rowKey ||
      //       this.tableStore.currentHoverRowKey === this.rowKey
      //     ) {
      //       return !!this.getColumns(key)?.readOnly;
      //     }
      //     // 其余返回 只读
      //     return true;
      //   }
      // }
    };
  }

  getMasterOrgDisabled(key: string) {
    const masterOrgField = this.getMasterOrgField()
    if (key === masterOrgField) {
      return this.getColumns(key)?.disabled !== undefined ? this.getColumns(key)?.disabled : false
    } else {
      return this.getColumns(key)?.disabled !== undefined ? this.getColumns(key)?.disabled : !!singleReferNullableType.includes(this.getTrueValue(masterOrgField))
    }
  }

  /**
   * 获取禁用状态
   */
  get disabled(): Function {
    return (key: string) => {
      if (this.readOnly()) {
        return this.getColumns(key)?.isDisabled;
      }
      if (this.getMasterOrgField()) {
        return this.getMasterOrgDisabled(key)
      }
      return this.getColumns(key)?.isDisabled
    }
  }

  /**
   * 获取必填状态
   */
  get required(): Function {
    return (key: string) => this.getColumns(key)?.isRequired;
  }

  /**
   * 获取显示状态
   */
  get visible(): Function {
    return (key: string) => this.getColumns(key)?.isVisible;
  }

  /**
   * 获取某列的错误信息
   */
  get errorTips(): Function {
    return (key: string) => {
      const err = this.errs.get(key) || [];
      if (err?.length > 0) {
        return err[0];
      } else {
        return "";
      }
    };
  }

  /**
   * 行内编辑按钮显示控制-审批中不显示编辑
   */
  get rowBtnEditVisible() {
    return this.toolBarStore.btnEditVisible
  }

  /**
   * 行内删除按钮显示控制
   */
  get rowBtnDeleteVisible() {
    return this.toolBarStore.btnDeleteVisible
  }

  /**
   * 行内编辑按钮-审批中显示编辑
   */
  get rowBtnEditWithApproveStatus() {
    return this.toolBarStore.btnEditWithApproveStatus
  }
}
